import { mdiAccountGroupOutline, mdiAccountClockOutline, mdiBroadcast, mdiCog, mdiHomeOutline, mdiLogout } from "@mdi/js";
import Icon from "@mdi/react";
import React from "react";
import { useSelector } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Logo from '../assets/logo.png'
import User from '../assets/user.png'

const tabs = [
  {
    img: mdiHomeOutline,
    text: "PROJECTS",
    next: "/projects"
  }, {
    img: mdiBroadcast,
    text: "LIVES",
    next: "/lives"
  },{
    img: mdiAccountClockOutline,
    text: "SESSIONS",
    next: "/sessions"
  }, {
    img: mdiAccountGroupOutline,
    text: "PARTICIPANTS",
    next: "/participants"
  },
]

const SideTab = ({img, text, isActive, next}) => {

  const navigate = useNavigate();
  const border = isActive ? "0.2rem solid #dee2e6" : ""; 
  const opacity = isActive ? "1" : "0.7"; 

  const goTo =() =>{
    navigate(next);
  }

  return (
    <div onClick={goTo} className={`border-primary py-2 my-2 d-flex h6 align-items-center hoverPointer px-3 head ${isActive ? "text-primary" : "text-secondary"}`} style={{borderLeft: border, opacity: opacity}}>
      <Icon path={img} size={0.8} /><span className="pl-3">{text}</span>
    </div>
  )
}

const Sidebar = ({activeTab}) => {
  const {userInfo} = useSelector((state) => state.user);

  const isSmall = window.innerWidth <= 991.98;
  const pos = isSmall ? "" : "fixed"
  return (
    <div className="d-flex flex-column h-100 pb-3" style={{position: pos}}>
      <CustomBrand className="no-decoration font-weight-bold h3 mb-4 d-flex align-items-center justify-content-center" to="/"><img src={Logo} alt="" width={60} />XPLOREUX</CustomBrand>
      {tabs.map((data, i) => (
        <SideTab img={data.img} key={i} text={data.text} next={data.next} isActive={i===activeTab} />
      ))}
      <div className="mt-auto">
        <div className="d-flex align-items-end">
          <img src={User} width="35%" alt="" />
          <div className="head small text-uppercase">
            <p className="mb-0 text-secondary" style={{opacity: "0.5"}}>Logged in as</p>
            <UserName>{userInfo?.name}</UserName>
          </div>
        </div>
        <SideTab img={mdiCog} text="SETTINGS" next="#" />
        <SideTab img={mdiLogout} text="LOGOUT" next="/login" />
      </div>
    </div>
    );
};

const CustomBrand = styled(Link)`
  font-family: 'Nunito', sans-serif;
  &:hover {
    color: #5D2CFF
  }
`;

const UserName = styled.p`
  width:20px;
  margin-bottom: 0;
`;

export default Sidebar;